import { HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

export type CoreInternalApiReplyCallback =
    | ((data: { request: HttpRequest<any>; urlParams: { [key: string]: string } }) => ([number, string | any]) | Observable<any>)
    | undefined;

export type CoreInternalApiMethods =
    | 'get'
    | 'post'
    | 'put'
    | 'patch'
    | 'delete';
